import { render, staticRenderFns } from "./VButton.vue?vue&type=template&id=1cb0b334&scoped=true&"
import script from "./VButton.vue?vue&type=script&lang=js&"
export * from "./VButton.vue?vue&type=script&lang=js&"
import style0 from "./VButton.vue?vue&type=style&index=0&id=1cb0b334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb0b334",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cb0b334')) {
      api.createRecord('1cb0b334', component.options)
    } else {
      api.reload('1cb0b334', component.options)
    }
    module.hot.accept("./VButton.vue?vue&type=template&id=1cb0b334&scoped=true&", function () {
      api.rerender('1cb0b334', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/VButton.vue"
export default component.exports